<template>
    <div>
        <p>{{ translations?.qrCodeText || 'Use and share unique QR for offline to online sources.' }}</p>
    </div>

    <div class="flex items-center p-9 bg-gradient-to-t from-gray-50 rounded-md -mx-9 -mb-8 rounded-b-none border-b text-sm">
        <div class="h-40 w-40 flex-shrink-0 mr-6 p-4 rounded-md bg-white border border-gray-200">
            <img id="qrcode" />
        </div>

        <ul class="flex-1 flex flex-col divide-y divide-gray-200">
            <li>
                <button class="w-full flex items-center py-3 px-4 hover:bg-gray-200 hover:bg-opacity-50 transition ease-in-out my-1 rounded-md" @click="download">
                    <div class="flex items-center space-x-2">
                        <icon name="download" />
                        <span>{{ translations?.download || 'Download' }}</span>
                    </div>
                </button>
            </li>
            <li>
                <modal
                    :title="translations?.embedCode || 'Embed code'"
                    :cancel_btn_title="translations?.cancel || 'Cancel'"
                    size="small"
                >
                    <template #toggle>
                        <button class="w-full flex items-center py-3 px-4 hover:bg-gray-200 hover:bg-opacity-50 transition ease-in-out my-1 rounded-md">
                            <div class="flex items-center space-x-2">
                                <icon name="code" />
                                <span>{{ translations?.embed || 'Embed' }}</span>
                            </div>
                        </button>
                    </template>
                    <template #body>
                        <div class="space-y-4">
                            <text-field :model-value="this.qrElement.outerHTML" readonly="true"></text-field>
                            <div class="ml-1" v-if="isCopied">{{ translations?.copied || 'Copied!' }}</div>
                        </div>
                    </template>
                    <template #footer>
                        <btn :type="buttonType" @click="copyEmbed">{{ translations?.copy || 'Copy' }}</btn>
                    </template>
                </modal>
            </li>
            <li>
                <button class="w-full flex items-center py-3 px-4 hover:bg-gray-200 hover:bg-opacity-50 transition ease-in-out my-1 rounded-md" @click="print">
                    <div class="flex items-center space-x-2">
                        <icon name="printer" />
                        <span>{{ translations?.print || 'Print' }}</span>
                    </div>
                </button>
            </li>
        </ul>

    </div>
</template>

<script>
import { copyToClipboard } from '../helpers/common.js';
import Qrious from 'qrious';

export default {
    props: {
        content: { type: String },
        name: {
            type: String,
            default: 'image'
        },
        buttonType: {
            type: String,
            default: ''
        },
        translations: {}
    },
    watch: {
        content: function() {
            // delay before making qr to reduce load
            clearTimeout(this.delay);
            this.delay = setTimeout(() => { this.makeQR(); }, 300);
        }
    },
    data() {
        return {
            qrElement: null,
            qrRender: null,
            delay: null,
            isCopied: false,
        }
    },
    mounted() {

        this.qrElement = document.getElementById("qrcode");

        this.qrRender = new Qrious({
            element: this.qrElement,
            padding: 10,
            size: 500,
        });

        this.makeQR();
    },
    methods: {
        copyToClipboard,
        makeQR() {
            this.qrRender.value = this.content;
        },
        download() {
            let a = document.createElement("a");
            a.href = this.qrElement.src;
            a.download = `qrcode_${this.name}.png`;
            a.click();
        },
        copyEmbed() {
            let text = this.qrElement.outerHTML;
            this.isCopied = copyToClipboard(text);;
            setTimeout(() => this.isCopied = false, 2000);
        },
        print() {
            let printWindow = window.open("about:blank", "_new");
            printWindow.document.open();
            printWindow.document.write(`
                <html>
                    <head></head>
                    <body onload="setTimeout(function() { window.print(); window.close(); }, 10);">
                        <img src="${this.qrElement.src}" />
                    </body>
                </html>
            `);
            printWindow.document.close();
        }
    }
}
</script>
